import {ActivityIcon, CandidateIcon, ClientIcon, JobIcon, ReportIcon, SettingsIcon, 
        SidebarAction, UsersIcon, CommunicationIcon, BackToHome} from '@/imports-files/common/common';


export function setSidebarIcons(type)
{
switch(type)
{
  case 'jobs':
            return <JobIcon className={`MainSidebar__Icon`} />
  case 'candidates':
            return <CandidateIcon className={`MainSidebar__Icon MainSidebar__FillIcon`} />
  case 'reports':
            return <ReportIcon className={`MainSidebar__Icon`} />
  case 'settings':
            return <SettingsIcon className={`MainSidebar__Icon`}/>
  case 'activities':
            return <ActivityIcon className={`MainSidebar__Icon`} />;
  case 'clients':
            return <ClientIcon className={`MainSidebar__Icon`} />;
  case 'users':
    return <UsersIcon className={`MainSidebar__Icon`} />;
  case 'communication':
            return <CommunicationIcon className={` Communication__Icon MainSidebar__Icon`} />;
  case "backToHome":
            return <BackToHome className={`MainSidebar__Icon`} />;
  default:'';
}

}
